import React, { useEffect, useState } from "react";
import PatientService from "../../../Services/PatientService";
import ConsultationService from "../../../Services/ConsultationService";
import DoctorService from "../../../Services/DoctorService";
import PrescriptionHeader from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionHeader";
import PrescriptionFooter from "../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionFooter";
import LabOrderService from "../../../Services/LabOrderService";

const LabOrderPreview = ({ medRecord }) => {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [doctorData, setDoctorData] = useState();
  const [hospitalAccountData, setHospitalAccountData] = useState(null);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  const [clinicDetails, setClinicDetails] = useState(null);
  const [labs, setLabs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let payload = {
      patientId: medRecord?.patientId,
    };
    PatientService.PatientListFilter(payload)
      .then((result) => {
        setSelectedPatientDetails(result.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching patient list:", error);
      });

    const fetchLabList = async () => {
      let medlistpayload = {
        consultationId: medRecord.consultationId,
        status: 1,
      };

      try {
        let labList = await LabOrderService.GetLabTestOrderDtl(medlistpayload);
        setLabs(labList.data);
      } catch (error) {
        console.error("error", error);
      }
    };
    fetchLabList();

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await getDoctorName(loginResultObject.user.userId);
        setDoctorData(response?.data[0]);
        fetchHospitalData(response?.data[0]?.account_Id);
        fetchClinicData(response?.data[0]?.clinic_Id);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getDoctorName = async (id) => {
    try {
      const response = await DoctorService.getDoctorData(id);
      return response;
    } catch (e) {
      console.error(e);
    }
  };

  const fetchHospitalData = async (id) => {
    const response = await DoctorService.getHospitalAccountData(id);
    setHospitalAccountData(response.data[0]);
  };

  const fetchClinicData = async (clinicId) => {
    const response = await ConsultationService.getClinicData(clinicId);
    setClinicDetails(response.data[0]);
  };

  const calculateAge = (dob) => {
    const dobData = dob;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  return (
    <section>
      <div
        id="prescription"
        className="w-full mb-4 border rounded overflow-x-auto cursor-pointer"
      >
        {isLoading ? (
          <div className="w-full flex h-screen justify-center items-center">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="md:p-3 p-4">
              <div className="md:flex justify-between"></div>
              <PrescriptionHeader
                clinicDetails={clinicDetails}
                doctorData={doctorData}
                hospitalAccountData={hospitalAccountData}
              />
              <div className="md:flex gap-5  my-4">
                <div className="text-sm font-bold flex gap-1">
                  Name:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.salutation
                      ? selectedPatientDetails?.salutation + " "
                      : ""}
                    {selectedPatientDetails?.firstName
                      ? selectedPatientDetails?.firstName + " "
                      : ""}
                    {selectedPatientDetails?.lastName
                      ? selectedPatientDetails?.lastName
                      : ""}
                  </span>
                </div>
                <div className="text-sm font-bold md:flex gap-1">
                  Age/Gender:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.dob
                      ? calculateAge(selectedPatientDetails?.dob)
                      : ""}
                    /
                    {selectedPatientDetails?.gender
                      ? selectedPatientDetails?.gender === "M"
                        ? "Male"
                        : "Female"
                      : ""}
                  </span>
                </div>
                <div className="text-sm font-bold md:flex gap-1">
                  Phone Number:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.mobile
                      ? selectedPatientDetails?.mobile
                      : ""}
                  </span>
                </div>

                <div className="text-sm font-bold flex gap-1">
                  Visit Type:
                  <span className=" text-sm text-gray-500 font-semibold">
                    {medRecord?.serviceName}
                  </span>
                </div>
              </div>

              <div className="w-full mx-auto bg-white shadow-md rounded-lg p-6">
                <table className="min-w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border px-4 py-2 text-left">Test Name</th>

                      <th className="border px-4 py-2 text-left">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {labs.map((lab, index) => (
                      <tr key={index}>
                        <td className="border px-2 py-2">{lab.labTestName}</td>

                        <td className="border  px-2 py-2">{lab.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        colSpan=""
                        className="border px-4 py-2 text-right font-semibold"
                      >
                        Total
                      </td>
                      <td className="border  px-2 py-2 font-semibold">
                        {parseFloat(medRecord.labAmount).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="mt-2">
                <PrescriptionFooter
                  clinicDetails={clinicDetails}
                  doctorData={doctorData}
                />
              </div>
              <div className="grid grid-cols-1">
                <div className="px-1 py-1">
                  <p className="text-gray-700 text-sm "></p>
                </div>
              </div>
            </div>
            l
          </>
        )}
      </div>
    </section>
  );
};

export default LabOrderPreview;
